import cug from "../../services/cug";

// initial state
const state = {
  status: "",
  token: "",
  expired_at: "",
  refresh_token: "",
  uuid: "",
  name: "",
  currentCustomerId: ""
};

// getters
const getters = {
  isLoggedIn: state => {
    return !!state.token;
  },

  getUuid: state => {
    return state.uuid;
  },

  getName: state => {
    return state.name;
  },

  getCurrentCustomerId: state => {
    return state.currentCustomerId;
  },

  getToken: state => {
    return state.token;
  },

  getRefreshToken: state => {
    return state.refresh_token;
  },

  expiredAt: state => {
    if (state.expired_at) {
      return new Date(state.expired_at * 1000);
    }
  },

  rememberMe: state => {
    return !!state.refresh_token;
  }
};

// actions
const actions = {
  login({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("request");
      let customer = {
        email: data.email,
        password: data.password,
        remember_me: data.rememberMe
      };
      cug
        .login(customer)
        .then(resp => {
          const data = resp.data;
          commit("success", {
            token: data.token,
            uuid: data.uuid,
            name: data.customers[0].firstname,
            currentCustomerId: data.customers[0].id,
            refresh_token: data.refresh_token,
            expired_at: data.expired_at
          });
          resolve(resp);
        })
        .catch(err => {
          commit("error");
          reject(err);
        });
    });
  },

  async refresh({ commit }) {
    return new Promise((resolve, reject) => {
      commit("request");
      cug
        .refresh()
        .then(resp => {
          const data = resp.data;
          commit("refresh", {
            token: data.token,
            refresh_token: data.refresh_token,
            expired_at: data.expired_at
          });
          resolve(resp);
        })
        .catch(err => {
          commit("error");
          reject(err);
        });
    });
  },

  logout({ commit }) {
    return new Promise(resolve => {
      commit("logout");
      resolve();
    });
  },

  createAccountFromInvitation({commit}, data) {
    return new Promise((resolve, reject) => {
      commit("request");
      let account = {
        invitation_token: data.invitationToken,
        online_account: {
          email: data.email,
          password: data.password,
          password_confirmation: data.passwordConfirmation,
        }
      };
      cug
        .createAccountFromInvitation(account)
        .then(resp => {
          const data = resp.data;
          commit("success", {
            token: data.token,
            uuid: data.uuid,
            name: data.customers[0].firstname,
            currentCustomerId: data.customers[0].id,
            refresh_token: data.refresh_token,
            expired_at: data.expired_at
          });
          resolve(resp);
        })
        .catch(err => {
          commit("error");
          reject(err);
        });
    });
  },

  setCurrentCustomer({ commit }, data) {
    commit("setCurrentCustomer", {
      currentCustomerId: data.id,
      name: data.name
    });
  }
};

// mutations
const mutations = {
  request(state) {
    state.status = "loading";
  },

  success(state, payload) {
    state.status = "success";
    state.token = payload.token;
    state.uuid = payload.uuid;
    state.name = payload.name;
    state.currentCustomerId = payload.currentCustomerId;
    state.refresh_token = payload.refresh_token;
    state.expired_at = payload.expired_at;
  },

  refresh(state, payload) {
    state.status = "success";
    state.token = payload.token;
    state.refresh_token = payload.refresh_token;
    state.expired_at = payload.expired_at;
  },

  setCurrentCustomer(state, payload) {
    state.status = "success";
    state.currentCustomerId = payload.currentCustomerId;
    state.name = payload.name;
  },

  error(state) {
    state.status = "error";
  },

  logout(state) {
    state.status = "";
    state.token = "";
    state.name = "";
    state.uuid = "";
    state.currentCustomerId = "";
    state.refresh_token = "";
    state.expired_at = "";
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
